/* This file is autogenerated, see readme.md for instructions */
import MobileTextMessageSvgIcon from '@bloomreach/banana-theme/icons/mobile-text-message.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const MobileTextMessageIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <MobileTextMessageSvgIcon />
    </Icon>
  );
});

MobileTextMessageIcon.displayName = 'MobileTextMessageIcon';

export default MobileTextMessageIcon;
